
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Terms() {
  const sections = [
    {
      title: "1. 服务条款的确认和接纳",
      content: [
        `会找我电商平台（以下简称"本平台"）的各项电子服务的所有权和运作权归本平台所有。`,
        `用户通过注册程序点击"我同意"按钮，即表示用户与本平台已达成协议，自愿接受本服务条款的所有内容。`,
        "本平台有权根据需要不时地制订、修改本协议或各类规则，如本协议有任何变更，将在网站上刊载公告，通知用户。",
        "如用户不同意相关变更，必须停止使用本平台提供的服务。如用户继续使用服务，则视为接受协议变更。"
      ]
    },
    {
      title: "2. 服务简介",
      content: [
        "本平台运用自己的操作系统通过国际互联网络为用户提供网络服务。",
        "用户必须：(1)提供设备，如个人电脑一台、调制解调器一个及配备上网装置。(2)个人上网和支付与此服务有关的电话费用、网络费用。",
        "考虑到网络服务的特殊性，用户同意：(1)提供详尽、准确的个人资料。(2)不断更新注册资料，符合及时、详尽、准确的要求。",
        "本平台不公开用户的姓名、地址、电子邮箱和笔名，但以下情况例外：(1)用户授权本站透露这些信息。(2)相应的法律及程序要求本站提供用户的个人资料。"
      ]
    },
    {
      title: "3. 用户账号",
      content: [
        "用户有义务保证密码和账号的安全，用户利用该密码和账号所进行的一切活动引起的任何损失或损害，由用户自行承担全部责任，本平台不承担任何责任。",
        "如用户发现账号遭到未授权的使用或发生其他任何安全问题，应立即修改账号密码并妥善保管，如有必要，请通知本平台。",
        "因黑客行为或用户的保管疏忽导致账号非法使用，本平台不承担任何责任。",
        "用户应当对以其用户账号进行的所有活动和事件负法律责任。"
      ]
    },
    {
      title: "4. 使用规则",
      content: [
        "用户在申请使用本平台网络服务时，必须向本平台提供准确的个人资料，如个人资料有任何变动，必须及时更新。",
        "用户注册成功后，本平台将给予每个用户一个用户账号及相应的密码，该用户账号和密码由用户负责保管。",
        "用户应当正确使用本平台提供的服务，不得利用本平台从事以下活动：",
        "• 上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：",
        "• 反对宪法所确定的基本原则的；",
        "• 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；",
        "• 损害国家荣誉和利益的；",
        "• 煽动民族仇恨、民族歧视、破坏民族团结的；",
        "• 含有法律、行政法规禁止的其他内容的。"
      ]
    },
    {
      title: "5. 商品信息",
      content: [
        "本平台上的商品价格、数量、规格等信息会实时更新，但由于网络传输等原因，可能存在短暂的信息延迟。",
        "商品的颜色可能会因您电脑显示器的色彩、亮度、对比度等设置不同而与实物存在色差，请您谅解。",
        "本平台会尽力确保您所浏览商品信息的准确性，但商品信息可能存在一定的滞后性或差错。",
        "如商品信息与实际情况不符，以实际商品为准。"
      ]
    },
    {
      title: "6. 订单与支付",
      content: [
        "用户在本平台购买商品时，需要按照页面提示填写相关信息并提交订单。",
        "订单提交后，用户需要在规定时间内完成支付，否则订单将被自动取消。",
        "本平台支持多种支付方式，包括但不限于支付宝、微信支付、银行卡支付等。",
        "支付完成后，本平台将安排商品的配送。用户可以在个人中心查看订单状态。"
      ]
    },
    {
      title: "7. 配送与验收",
      content: [
        "本平台将按照用户选择的配送方式和地址进行商品配送。",
        "配送时间可能因商品库存、配送地址、天气等因素而有所不同。",
        "用户收到商品后应当及时验收，如发现商品有质量问题或与订单不符，应在收货后24小时内联系客服。",
        "对于生鲜类商品，我们承诺坏果包赔，确保商品质量。"
      ]
    },
    {
      title: "8. 退换货政策",
      content: [
        "除特殊商品外，用户可在收到商品后7天内申请退换货。",
        "退换货的商品必须保持原有包装和状态，不影响二次销售。",
        "生鲜类商品如有质量问题，支持坏果包赔政策。",
        "退换货产生的运费，如因商品质量问题由本平台承担，如因用户个人原因由用户承担。"
      ]
    },
    {
      title: "9. 隐私保护",
      content: [
        "本平台非常重视用户隐私的保护。除本协议另有规定外，本平台不会向第三方透露用户的个人信息。",
        "本平台会采取合理的安全措施保护用户的个人信息，防止信息的丢失、滥用和误用。",
        "用户同意本平台可以在以下情况下使用用户的个人信息：",
        "• 为用户提供服务；",
        "• 改进本平台的服务质量；",
        "• 向用户发送服务相关的通知；",
        "• 法律法规要求的其他情况。"
      ]
    },
    {
      title: "10. 免责声明",
      content: [
        "用户明确同意其使用本平台网络服务所存在的风险将完全由其自己承担。",
        "本平台不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断。",
        "对于因不可抗力或本平台不能控制的原因造成的网络服务中断或其它缺陷，本平台不承担任何责任。",
        "本平台不保证为向用户提供便利而设置的外部链接的准确性和完整性。"
      ]
    },
    {
      title: "11. 协议修改",
      content: [
        "本平台有权随时修改本协议的任何条款，一旦本协议的内容发生变动，本平台将会通过适当方式向用户提示修改内容。",
        "如果不同意本平台对本协议相关条款所做的修改，用户有权停止使用网络服务。",
        "如果用户继续使用网络服务，则视为用户接受本平台对本协议相关条款所做的修改。",
        "本协议的修改、解释权均属本平台所有。"
      ]
    },
    {
      title: "12. 法律适用",
      content: [
        "本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。",
        "如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决。",
        "协商不成时，任何一方均可向本平台所在地的人民法院提起诉讼。",
        "本协议的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Header */}
        <section className="bg-gray-50 py-12">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-3xl font-bold text-gray-800 mb-4">用户协议</h1>
              <p className="text-gray-600">
                最后更新时间：2025年9月1日
              </p>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
                <h2 className="text-xl font-semibold text-blue-800 mb-3">重要提示</h2>
                <p className="text-blue-700 leading-relaxed">
                  欢迎您使用会找我电商平台！请您仔细阅读以下条款。当您注册成为用户时，表示您已充分阅读、理解并接受本协议的全部内容，
                  并与会找我平台达成一致，同意严格遵守本协议。本协议具有法律效力，如您不同意本协议的任意内容，请勿注册或使用本平台服务。
                </p>
              </div>

              <div className="space-y-8">
                {sections.map((section, index) => (
                  <div key={index} className="border-b border-gray-200 pb-8 last:border-b-0">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                      {section.title}
                    </h2>
                    <div className="space-y-3">
                      {section.content.map((paragraph, pIndex) => (
                        <p key={pIndex} className="text-gray-600 leading-relaxed">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

           
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
